import React from 'react';
import { Box, Text } from '@wix/design-system';
import { Platforms } from '@wix/ambassador-partners-profile-v1-partner-profile/types';
import s from './About.module.scss';

type Props = {
  text: string;
  platforms?: Platforms;
  isMobileView?: boolean;
};

const PlatformDisplay: React.FC<Props> = ({
  text,
  platforms,
  isMobileView,
}) => {
  const { studio, wix } = platforms || {};

  let platformText = '';
  if (wix && studio) {
    platformText = 'Wix & Wix Studio';
  } else if (wix) {
    platformText = 'Wix';
  } else if (studio) {
    platformText = 'Wix Studio';
  }

  return studio || wix ? (
    <Box
      className={s.platformDisplay}
      direction="horizontal"
      verticalAlign="middle"
      gap="3.33px"
    >
      <Text size="small">{text}</Text>
      <Text size="small">{platformText}</Text>
    </Box>
  ) : null;
};

export default PlatformDisplay;
